import { Card, Col, Row, Text, TitledText } from '@/components';
import type { PlanModel } from '@/features/project/projects/_models/project';
import { FALLBACK_TEXT } from '@/utils';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

export const PlanCard = ({ plan }: { plan: z.infer<typeof PlanModel> }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Text text={plan.contents} />
        </Col>

        <Col span={24}>
          <TitledText
            title={t('plan-url')}
            variant="link"
            text={plan.url ?? FALLBACK_TEXT}
            href={plan.url ?? ''}
          />
        </Col>
      </Row>
    </Card>
  );
};
